import {
	GET_DASHBOARD_SUMMARY_REQUEST,
	GET_DASHBOARD_SUMMARY_SUCCESS,
	GET_DASHBOARD_SUMMARY_FAILED,
	GET_DASHBOARD_CHART_REQUEST,
	GET_DASHBOARD_CHART_SUCCESS,
	GET_DASHBOARD_CHART_FAILED,
	CLEAR_DASHBOARD_ERRORS
} from '../actions/DashboardActions';

const initialState = {
	summary: {
		companies: { active: 0, pending: 0, inactive: 0 },
		users: { active: 0, pending: 0, inactive: 0 },
		depositors: { active: 0, pending: 0, inactive: 0 },
		deposits: {
			active: 0,
			pending: 0,
			inactive: 0,
			amount_active: 0,
			amount_pending: 0,
			amount_inactive: 0
		},
		loans: {
			active: 0,
			pending: 0,
			inactive: 0,
			amount_active: 0,
			amount_pending: 0,
			amount_inactive: 0
		},
		interestPaid: { active: 0, pending: 0, inactive: 0 },
		interestReceived: { active: 0, pending: 0, inactive: 0 }
	},
	charts: {
		day: {
			interestPaid: [],
			interestReceived: [],
			loansCreated: []
		},
		week: {
			interestPaid: [],
			interestReceived: [],
			loansCreated: []
		},
		month: {
			interestPaid: [],
			interestReceived: [],
			loansCreated: []
		},
		year: {
			interestPaid: [],
			interestReceived: [],
			loansCreated: []
		}
	},
	loading: false,
	chartLoading: false,
	error: null
};

const DashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_DASHBOARD_SUMMARY_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case GET_DASHBOARD_SUMMARY_SUCCESS:
			return {
				...state,
				loading: false,
				summary: action.payload,
				error: null
			};
		case GET_DASHBOARD_SUMMARY_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		case GET_DASHBOARD_CHART_REQUEST:
			return {
				...state,
				chartLoading: true,
				error: null
			};
		case GET_DASHBOARD_CHART_SUCCESS:
			const { period, data } = action.payload;
			return {
				...state,
				chartLoading: false,
				charts: {
					...state.charts,
					[period]: data
				},
				error: null
			};
		case GET_DASHBOARD_CHART_FAILED:
			return {
				...state,
				chartLoading: false,
				error: action.payload
			};
		case CLEAR_DASHBOARD_ERRORS:
			return {
				...state,
				error: null
			};
		default:
			return state;
	}
};

export default DashboardReducer;
